import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ClipStatus } from "@air/api/types";
import { formatDateVerbose } from "@air/utilities";
import classNames from "classnames";
import { memo, useMemo } from "react";
import { AssetMobileVersionsListItemThumbnailPreview } from "~/_components/AssetMobileVersionsListItemThumbnailPreview";
import { ImgixImage } from "~/components/ImgixImage";
import { getCloudFrontUrlFromImgixUrl } from "~/constants/cloudfront";
export const AssetMobileVersionsItem = /*#__PURE__*/ memo((param)=>{
    let { isActive, onClick, version } = param;
    const showPreview = useMemo(()=>{
        return version.status === ClipStatus.nonTranscodable || version.status === ClipStatus.failed;
    }, [
        version.status
    ]);
    const fallbackUrl = useMemo(()=>{
        return !!version.assets.image && getCloudFrontUrlFromImgixUrl(version.assets.image);
    }, [
        version.assets.image
    ]);
    return /*#__PURE__*/ _jsxs("button", {
        className: "flex w-full items-center gap-4 text-left",
        onClick: onClick,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: classNames("pointer-events-none relative h-16 w-24 shrink-0 overflow-hidden rounded-sm", isActive && "ring-2 ring-blue-9 ring-offset-1 ring-offset-white dark:ring-offset-black"),
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "absolute bottom-1 right-1 rounded-sm bg-black/80 px-1 py-0.5 text-10 font-bold uppercase tracking-wider text-grey-12",
                        children: [
                            "V",
                            version.version
                        ]
                    }),
                    showPreview ? /*#__PURE__*/ _jsx(AssetMobileVersionsListItemThumbnailPreview, {
                        ext: version.ext
                    }) : fallbackUrl ? /*#__PURE__*/ _jsx(ImgixImage, {
                        alt: version.title || version.importedName || "",
                        src: version.assets.image,
                        fallbackUrl: fallbackUrl,
                        imgixParams: {
                            fit: "crop",
                            auto: "compress",
                            w: 96,
                            h: 64,
                            cs: "origin"
                        },
                        height: 64,
                        width: 96
                    }) : null
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "grow",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "truncate text-14 font-semibold text-grey-12",
                        children: version.title || version.importedName
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-12 font-medium text-grey-11",
                        children: formatDateVerbose(version.createdAt)
                    })
                ]
            })
        ]
    });
});
AssetMobileVersionsItem.displayName = "AssetMobileVersionsItem";
